export const queryKeys = {
  DEFAULT_CREATE: 'DEFAULT_CREATE',
  DEFAULT_CREATE_LEAD: 'DEFAULT_CREATE_LEAD',
  GET_REQUIRED_FIELDS: 'GET_REQUIRED_FIELDS',
  GET_LEAD_CLIENT: 'GET_LEAD_CLIENT'
};
